import { useCallback, useEffect } from 'react';
import { loadScriptAsync } from '@wbk/utils';

type Props = {
  onLoaded?: () => void;
  onError?: (error: Error) => void;
  children: React.ReactNode;
  recaptchaKey: string;
};

const WithGrecaptcha = ({ children, onLoaded, onError, recaptchaKey }: Props) => {
  const loadV3Script = useCallback(async () => {
    try {
      if (!recaptchaKey) {
        throw new Error('No reCAPTCHA v3 key found in env');
      }

      const url = `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`;
      await loadScriptAsync({ id: 'recaptcha_script', url });

      if (onLoaded) {
        onLoaded();
      }
    } catch (err) {
      const error = err as Error;

      if (onError) {
        onError(error);
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    loadV3Script();
  }, [loadV3Script]);

  return children;
};

export default WithGrecaptcha;
